import styled from 'styled-components'

import { flexCol } from '~/shared/styles/layout'

/**
 *
 */

export const List = styled.ul`
  ${flexCol}
  align-items: flex-start;
  width: 100%;
  height: 100%;
  overflow-x: ${(props) =>
    // @ts-expect-error TS(2339) FIXME: Property 'oveflow' does not exist on type 'ThemedS... Remove this comment to see the full error message
    props.oveflow ? 'visible' : 'hidden'};
  list-style-type: none;
  padding: ${(props) =>
    // @ts-expect-error TS(2339) FIXME: Property 'withPadding' does not exist on type 'The... Remove this comment to see the full error message
    props.withPadding ? '8px' : '0px'};
`

export const ListItem = styled.li`
  width: 100%;
`
